import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import ProgressTab from '../../components/ProgressTab';
import { SITE_LINKS } from '../../constants';
import { useGetLiveClassHistory } from '../../hooks/use-get-live-class-history';
import { Background } from '../../stories/Background';
import { LiveClassList } from '../../stories/LiveClassList';
import ResponsivePageHeader from '../../stories/ResponsivePageHeader';

export const LiveClassHistoryPage = () => {
  const __ = useTranslation().t;
  const { liveClasses, isFetching, isError } = useGetLiveClassHistory();

  if (isError) {
    window.location.href = SITE_LINKS.HomePage;
    return null;
  }

  return (
    <>
      <DefaultHeader activeItem={__('progress')} />
      <Background>
        <ResponsivePageHeader text={__('myProgress')} />
        <ProgressTab activeKey={__('liveClassHistory')} />
        <Container>
          <div className="oejr-page-lc-history">
            {isFetching ? <LoadingContainer /> : <LiveClassList liveClasses={liveClasses} />}
          </div>
        </Container>
      </Background>
    </>
  );
};
